export default "__VITE_ASSET__BFyM8$HA__"